import React, { useContext } from 'react';

import { os } from '@mirinae/js-utils/utils/userAgent';
import { FooterComponent } from '@mirinae/react-gnb';

import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import { useAppVersionStore } from '@mirinae/stores/appVersion';
import Localization, { langsSelectList } from '@mirinae/shared/il8n';

const FooterContainer = () => {
    const isApp = useAppVersionStore(state => state.isApp);

    const global = useContext(GlobalContext);

    const handleFeedback = () => {
        global.update({ displayFeedback: 1 });
    };

    // hide if in app or Lesson Player page
    return isApp || location.pathname.indexOf(lessonsPaths.player) !== -1 || location.pathname.indexOf(lessonsPaths.home) === 0 || (!os.isOthers && location.pathname.indexOf(lessonsPaths.onelesson) !== -1) ? null : (
        <FooterComponent
            isApp={isApp}
            onClickFeedback={handleFeedback}
            localization={Localization}
        />
    );
};

export default FooterContainer;